import React from "react";
import {
  LinearProgress,
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const processDriverData = (data) => {
  let ordersByDay = {};
  let comunas = {};
  let origins = {};
  let totalEntregas = 0;
  let totalNoEntregas = 0;
  let totalPendientes = 0;
  let ordersByMonthYear = {};

  data.forEach((order) => {
    // Procesar fechas para agrupar por día
    const date = new Date(order.createdAt.seconds * 1000); // Convertir timestamp de Firebase a fecha
    const day = date.toISOString().split("T")[0]; // Solo la parte YYYY-MM-DD
    const monthYear = `${date.getFullYear()}-${date.getMonth() + 1}`;

    // Agrupar órdenes por día
    if (!ordersByDay[day]) {
      ordersByDay[day] = 0;
    }
    ordersByDay[day]++;

    // Agrupar comunas visitadas
    if (!comunas[order.comuna]) {
      comunas[order.comuna] = 0;
    }
    comunas[order.comuna]++;

    // Agrupar orígenes
    if (!origins[order.placeName]) {
      origins[order.placeName] = 0;
    }
    origins[order.placeName]++;

    // Contar total de entregas, no entregas y pendientes
    if (order.status === 8) {
      totalEntregas++;
    } else if (order.status < 8) {
      totalNoEntregas++;
    } else if (order.status < 8) {
      totalPendientes++;
    }

    // Agrupar por mes y año
    if (!ordersByMonthYear[monthYear]) {
      ordersByMonthYear[monthYear] = 0;
    }
    ordersByMonthYear[monthYear]++;
  });

  return {
    ordersByDay,
    comunas,
    origins,
    totalEntregas,
    totalNoEntregas,
    totalPendientes,
    ordersByMonthYear,
  };
};

const Historial = ({ driverOperationData }) => {
  if (!driverOperationData) return <LinearProgress />;

  const {
    ordersByDay,
    comunas,
    origins,
    totalEntregas,
    totalNoEntregas,
    totalPendientes,
    ordersByMonthYear,
  } = processDriverData(driverOperationData);

  // ------------------------------------------------------------
  // 1) Órdenes por día (máx 30 días más recientes)
  // ------------------------------------------------------------
  // Ordena por key y toma las últimas 30
  const ordersByDayEntries = Object.entries(ordersByDay || {}).sort(
    ([a], [b]) => a.localeCompare(b)
  ); // si es YYYY-MM-DD queda OK
  const last30DayEntries = ordersByDayEntries.slice(-30);

  const ordersByDayLabels = last30DayEntries.map(([k]) => k);
  const ordersByDayData = last30DayEntries.map(([, v]) => v);

  const ordersByDayChartData = {
    labels: ordersByDayLabels,
    datasets: [
      {
        label: "Órdenes por día (últimos 30 días)",
        data: ordersByDayData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };

  // ------------------------------------------------------------
  // Comunas (si luego quieres torta, lo cambiamos igual)
  // ------------------------------------------------------------
  const comunasLabels = Object.keys(comunas || {});
  const comunasData = Object.values(comunas || {});
  const comunasChartData = {
    labels: comunasLabels,
    datasets: [
      {
        label: "Comunas visitadas",
        data: comunasData,
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
    ],
  };

  // ------------------------------------------------------------
  // 2) Orígenes (Pie)
  // ------------------------------------------------------------
  const originsLabels = Object.keys(origins || {});
  const originsData = Object.values(origins || {});
  const originsChartData = {
    labels: originsLabels,
    datasets: [
      {
        label: "Orígenes",
        data: originsData,
        backgroundColor: "rgba(85, 179, 209, 0.6)",
      },
    ],
  };

  // ------------------------------------------------------------
  // 3) Orígenes por mes y año (Pie)
  // ------------------------------------------------------------
  const ordersByMonthYearLabels = Object.keys(ordersByMonthYear || {});
  const ordersByMonthYearData = Object.values(ordersByMonthYear || {});
  const ordersByMonthYearChartData = {
    labels: ordersByMonthYearLabels,
    datasets: [
      {
        label: "Orígenes por mes-año",
        data: ordersByMonthYearData,
        backgroundColor: "rgba(153, 102, 255, 0.6)",
      },
    ],
  };

  return (
    <Box>
      {/* Órdenes por día (últimos 30 días) */}
      <Typography variant="h6">Órdenes por día (últimos 30 días)</Typography>
      <Bar data={ordersByDayChartData} />

      {/* (Opcional) Comunas - lo dejo como estaba */}
      {/* <Typography variant="h6" mt={4}>Comunas visitadas</Typography>
      <Bar data={comunasChartData} /> */}

      {/* Orígenes (torta) */}
      <Typography variant="h6" mt={4}>
        Orígenes
      </Typography>
      <Box sx={{ maxWidth: 520 }}>
        <Pie data={originsChartData} />
      </Box>

      {/* Orígenes por mes y año (torta) */}
      <Typography variant="h6" mt={4}>
        Orígenes por mes y año
      </Typography>
      <Box sx={{ maxWidth: 520 }}>
        <Pie data={ordersByMonthYearChartData} />
      </Box>

      {/* Totales */}
      <Box mt={4}>
        <Typography variant="h6">Totales</Typography>
        <List>
          <ListItem>
            <ListItemText primary={`Total entregas: ${totalEntregas}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Total no entregas: ${totalNoEntregas}`} />
          </ListItem>
          <ListItem>
            <ListItemText primary={`Total pendientes: ${totalPendientes}`} />
          </ListItem>
        </List>
      </Box>
    </Box>
  );
};

export default Historial;
